import { View } from "@gluestack-ui/themed";
import { PreProposalScreens } from "@repo/core/screens/PreProposal";

const PreProposalCaptureDocumentScreen = () => {
  return (
    <View flex={1} h="$full" w="$full">
      <PreProposalScreens.CaptureDocument />
    </View>
  );
};

export default PreProposalCaptureDocumentScreen;
